import {useEffect,useRef,useState} from 'preact/hooks';
import {createPortal} from 'preact/compat';
import {Emf,EoWriter} from 'eolib';
import {Button} from './button';
import {useClient} from '@/ui/context';
import {sendRoomAction,type RoomSnapshot} from '@/private-rooms';
import {UI_PANEL_BG,UI_PANEL_BORDER} from '@/ui/consts';
import {WORLD_ID} from '@/world';

export function HouseDesignPanel({house,pending}:{house:NonNullable<RoomSnapshot['house_design']>;pending:boolean}){
 const client=useClient(),frame=useRef<HTMLIFrameElement>(null),nonce=useRef(crypto.randomUUID());
 const [open,setOpen]=useState(false),[error,setError]=useState(''),[confirming,setConfirming]=useState(false);
 useEffect(()=>{
  if(!open)return;
  const receive=(event:MessageEvent)=>{
   if(event.origin!==location.origin||event.source!==frame.current?.contentWindow)return;
   if(event.data?.type==='lulseo-house-ready'){
    const writer=new EoWriter();Emf.serialize(writer,client.map);
    frame.current!.contentWindow!.postMessage({type:'lulseo-house-init',nonce:nonce.current,bytes:writer.toByteArray(),protected:house.protected},location.origin);
   }else if(event.data?.type==='lulseo-house-quote'&&event.data.nonce===nonce.current){
    const edits=event.data.edits;
    if(!Array.isArray(edits)||!edits.length||edits.length>100||edits.some(e=>![0,1,9].includes(e.cell?.layer)||!Number.isInteger(e.graphic)))return;
    setError(sendRoomAction(client,'house_quote',JSON.stringify(edits))?'':'Please wait for the current request to finish.');
   }
  };
  window.addEventListener('message',receive);return()=>window.removeEventListener('message',receive);
 },[client,open,house.key,house.revision]);
 useEffect(()=>{setOpen(false);nonce.current=crypto.randomUUID();},[house.key,house.revision]);
 useEffect(()=>setConfirming(false),[house.quote?.operation]);
 return <section class={`border ${UI_PANEL_BORDER} p-2 space-y-2`}>
  <h3 class='font-bold'>Decorate your {house.guild?'guild house':'house'}</h3>
  <p>Choose floors, furniture and special tiles. {house.guild?'Only the guild leader can edit. The guild gold bank pays for changes.':'Your changes stay inside this house.'}</p>
  <Button variant={['sm','primary']} disabled={pending} onClick={()=>setOpen(true)}>Open house mapper</Button>
  {open&&createPortal(<div data-house-mapper class={`fixed inset-2 z-[1000] flex flex-col rounded border ${UI_PANEL_BORDER} ${UI_PANEL_BG}`} onPointerDown={e=>e.stopPropagation()}>
   <div class='flex flex-wrap items-center justify-between gap-2 p-2'>
    <strong>{house.guild?'Guild house':'House'} #{house.key} · Private design</strong>
    <p class='text-xs'>Objects 1,000g · Ground/special 500g per 10 changes</p>
    <Button variant={['sm']} onClick={()=>setOpen(false)}>Close mapper</Button>
   </div>
   <iframe ref={frame} title='Your home mapper' src={`/house-editor/?world=${WORLD_ID}`} class='min-h-0 flex-1 w-full border-0'/>
   <div class='flex items-center gap-2 p-2'>
    <span>{error||'Choose a graphic and paint the map. Click Get exact quote in the mapper.'}</span>
    {house.quote&&(confirming?<><span>Spend {house.quote.cost.toLocaleString()} {house.guild?'guild bank ':''}gold?</span><Button variant={['sm','primary']} disabled={pending} onClick={()=>sendRoomAction(client,'house_edit',house.quote!.operation)}>Confirm purchase</Button><Button variant={['sm']} onClick={()=>setConfirming(false)}>Cancel</Button></>:<Button variant={['sm','primary']} disabled={pending} onClick={()=>setConfirming(true)}>Apply changes — {house.quote.cost.toLocaleString()} gold</Button>)}
   </div>
  </div>,document.getElementById('ui')??document.body)}
 </section>;
}
